const hostname = window.location.hostname;
let envName = "local";
let visibility = "internal";
if (hostname === "developer.code.siemens.io") {
  envName = "review";
  if (window.location.pathname.includes("/preview_site/")) {
    visibility = "preview";
  } else if (window.location.pathname.includes("/public_site/")) {
    visibility = "public";
  }
}
if (hostname === "dev.developer.siemens.com") {
  envName = "dev";
  visibility = "public";
}
if (hostname === "preview.dev.developer.siemens.com") {
  envName = "dev";
  visibility = "preview";
}
if (hostname === "dev.developer.internal.siemens.com") {
  envName = "dev";
  visibility = "internal";
}
if (hostname === "stage.developer.siemens.com") {
  envName = "stage";
  visibility = "public";
}
if (hostname === "preview.stage.developer.siemens.com") {
  envName = "stage";
  visibility = "preview";
}
if (hostname === "stage.developer.internal.siemens.com") {
  envName = "stage";
  visibility = "internal";
}
if (hostname === "developer.siemens.com") {
  envName = "prod";
  visibility = "public";
}
if (hostname === "preview.developer.siemens.com") {
  envName = "prod";
  visibility = "preview";
}
if (hostname === "developer.internal.siemens.com") {
  envName = "prod";
  visibility = "internal";
}

async function onPerformanceCookiesEnabled(callback) {
  let retries = 0;
  const maxRetries = 20;
  const retryDelay = 250; // milliseconds
  while (retries < maxRetries) {
    if (typeof cookieMonster === "object" && typeof cookieMonster.permitted === "function") {
      return cookieMonster.once("perf", callback);
    }
    retries++;
    await new Promise((resolve) => setTimeout(resolve, retryDelay));
  }
  console.warn(`Cookie Monster not defined after ${maxRetries} retries, assuming performance cookies are not enabled.`);
  return false;
}

function enableDatadogTracking() {
  let serviceName = "developer.siemens.com";
  let clientToken = "pub0f3ae1b614ba32fbbbf4c5102b1d1934";
  let applicationId = "54cdba1a-8659-499d-a052-c5880e5464ab";
  if (visibility === "internal") {
    serviceName = "developer.internal.siemens.com";
    clientToken = "pub27b4bbda720a66bf74a6a8c9da32b7db";
    applicationId = "196bc96b-c5e0-4b1c-9d01-921d2769043b";
  }
  window.DD_RUM.onReady(function () {
    window.DD_RUM.init({
      clientToken: clientToken,
      applicationId: applicationId,
      // `site` refers to the Datadog site parameter of your organization
      // see https://docs.datadoghq.com/getting_started/site/
      site: "datadoghq.eu",
      service: serviceName,
      env: envName,
      // Specify a version number to identify the deployed version of your application in Datadog
      // version: '1.0.0',
      sessionSampleRate: 100,
      sessionReplaySampleRate: 20,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: "mask-user-input",
    });
  });
}

function enableMatomoTracking() {
  var _mtm = (window._mtm = window._mtm || []);
  _mtm.push({ "mtm.startTime": new Date().getTime(), "event": "mtm.Start" });
  var d = document,
    g = d.createElement("script"),
    s = d.getElementsByTagName("script")[0];
  g.async = true;

  let filename = "";
  if (visibility === "public" || visibility === "preview") {
    filename = "container_kWOcpn9t_dev_8de3671d06370c9eb68eecbe.js";
    if (envName === "stage") {
      filename = "container_kWOcpn9t_stage_993183c5084bea0290e30dd8.js";
    } else if (envName === "prod") {
      filename = "container_kWOcpn9t.js";
    }
  } else {
    filename = "container_JW5XuYRB_dev_6f48d9d2959b0f80511d49cd.js";
    if (envName === "stage") {
      filename = "container_JW5XuYRB_stage_dd2b257ef0decf887d75f1dd.js";
    } else if (envName === "prod") {
      filename = "container_JW5XuYRB.js";
    }
  }
  g.src = "https://w3.siemens.com/js/" + filename;
  s.parentNode.insertBefore(g, s);
}

function enableHotjarTracking() {
  (function (h, o, t, j, a, r) {
    h.hj =
      h.hj ||
      function () {
        (h.hj.q = h.hj.q || []).push(arguments);
      };
    h._hjSettings = { hjid: 3319083, hjsv: 6 };
    a = o.getElementsByTagName("head")[0];
    r = o.createElement("script");
    r.async = 1;
    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
    a.appendChild(r);
  })(window, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=");
}

onPerformanceCookiesEnabled(() => {
  console.log("Performance cookies are enabled, initializing tracking.");
  enableDatadogTracking();
  enableMatomoTracking();
  enableHotjarTracking();
});
